// Shared tab filtering for the .js-section-card-slider card layout (Popular products,
// Collection list). Tabs are rendered by the heading group; every card carries the
// filter handles it belongs to in data-card-filter.
(function () {
  const initCardFilters = (section) => {
    if (!section || typeof section.querySelectorAll !== "function") return;

    const filterItems = section.querySelectorAll("[data-filter-target]");
    const cardItems = section.querySelectorAll("[data-card-filter]");
    if (filterItems.length === 0 || cardItems.length === 0) return;

    // two sections on one page load this asset twice, so each copy would otherwise
    // bind a second click listener onto the same tabs
    if (section.dataset.cardFiltersInit === "true") return;
    section.dataset.cardFiltersInit = "true";

    const sliderEl = section.querySelector(".js-section-card-slider");
    const paginationEl = section.querySelector(".slider-pagination");

    // Rewind while the old set of slides is still in place: once the tab's cards
    // are hidden the previous tab's activeIndex points into a shorter snapGrid,
    // and the progress pagination scales past its own track before sliding back.
    const rewindSlider = () => {
      const swiper = sliderEl?.swiper;
      if (!swiper) return;

      if (swiper.params.loop) {
        swiper.slideToLoop(0, 0, false);
      } else {
        swiper.slideTo(0, 0, false);
      }
    };

    // Swiper stamps the slide speed onto the progress fill, so the recomputed
    // length would sweep in from the previous tab's fill. Cut the transition for
    // the swap and hand it back once the new fill has been painted.
    const snapPagination = () => {
      const fill = paginationEl?.querySelector(
        ".swiper-pagination-progressbar-fill"
      );
      if (!fill) return;

      fill.style.transition = "none";
      requestAnimationFrame(() => {
        requestAnimationFrame(() => {
          fill.style.transition = "";
        });
      });
    };

    const refreshSlider = () => {
      const swiper = sliderEl?.swiper;
      if (!swiper) return;

      swiper.update();
      swiper.pagination?.update();
      swiper.navigation?.update();
      snapPagination();
    };

    const filterOnClick = (filterItem) => {
      const filterTarget = filterItem.dataset.filterTarget;
      if (!filterTarget) return;

      if (filterItem.classList.contains("active")) return;
      filterItems.forEach((item) => item.classList.remove("active"));
      filterItem.classList.add("active");

      rewindSlider();

      cardItems.forEach((item) => {
        const cardFilter = item.dataset.cardFilter || "";
        const filterValues = cardFilter.split(",").map((v) => v.trim());

        item.style.display = filterValues.includes(filterTarget) ? "" : "none";
      });

      refreshSlider();
    };

    filterItems.forEach((filterItem) => {
      filterItem.addEventListener("click", () => {
        filterOnClick(filterItem);
      });
    });
  };

  initCardFilters(document.currentScript.parentElement);

  if (!window.__sectionCardFiltersEvents) {
    window.__sectionCardFiltersEvents = true;
    document.addEventListener("shopify:section:load", function (event) {
      initCardFilters(event.target);
    });
  }
})();
